import { render, staticRenderFns } from "./CartItemsList.vue?vue&type=template&id=556a0d42"
import script from "./CartItemsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartItemsList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartsCartItemsListItem: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/carts/CartItemsListItem.vue').default,CDivider: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CDivider/CDivider.vue').default})
